import React from "react";
import { userProfile } from "./UserContext.d";

export const initialUserContext: userProfile = {
	storeLocation: "",
	storeNumber: 0,
	officeLocation: "",
	displayName: "",
	givenName: "",
	surname: "",
	staffId: "",
	roles: [""],
	photo: "",
};

export const UserContext = React.createContext<userProfile>(initialUserContext);
